/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { DecisionContainer } from '../../containers';
import _ from 'lodash';

import v from './validators';
import fetch from '../../core/fetch';
import loadingData from './loading';
import AttachmentsPanel from '../../components/AttachmentsPanel';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const InfoTypeDict = {
  wlasciciel: {
    label: 'Właściciel nieruchomości',
    editable: true,
  },
  polozenie: {
    label: 'Położenie obszaru objętego podziałem (adres, sąsiedztwo)',
    editable: true,
  },
  komunikacja: {
    label: 'Zasady obsługi komunikacyjnej (dostęp do drogi publicznej, ewent. konieczne służebności komunikacyjne)',
    editable: true,
  },
  infrastruktura: {
    label: 'Ewentualne zasady obsługi w zakresie infrastruktury technicznej – wymagane służebności dostępu',
    editable: true,
  },
  cel: {
    label: 'Cel podziału, przeznaczenie działek po podziale',
    editable: true,
  }
};


class OpiniaPodzialu extends React.Component {
  state = {
    info: {
      wlasciciel: null,
      polozenie: null,
      komunikacja: null,
      infrastruktura: null,
      cel: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    attachments: null,
    loading: false,
    isMounted: false,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    wlasciciel: [v.NotNull],
    polozenie: [v.NotNull],
    komunikacja: [v.NotNull],
    infrastruktura: [v.NotNull],
    cel: [v.NotNull]
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp
        }, () => this.updateValidators());
      })

    this.setState({ isMounted: true });
  }

  updateValidators = () => {
    if (this.props.prefix === 'gmina_komarow_osada') {
      this.validators = {
        wlasciciel: [],
        polozenie: [],
        komunikacja: [],
        infrastruktura: [],
        cel: []
      }
    }
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (this.props.prefix != 'gmina_komarow_osada') {
      if (!this.state.attachments || this.state.attachments.length === 0) {
        this.setState({
          errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
          errorTitle: 'Brak załączników.',
          showError: true,
          loading: false,
        });
        return;
      }
    }


    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          mpzpOwner: { ...this.state.mpzpOwner },
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          numer_ksiegi: this.state.info.numer_ksiegi,
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />

        <GrayPanel
          title={'1. Teren'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        {this.props.prefix != 'gmina_komarow_osada' ?
          <DecisionContainer
            title={'2. Informacje'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={InfoTypeDict}
            onChange={e => this.onChange(e, 'info')}
          />
        : null}

        {this.props.prefix != 'gmina_komarow_osada' ?
          <GrayPanel title={'Informacja dla wnioskodawcy'}>
            <p>
              Do wniosku  należy załączyć:
            </p>
            <ol>
              <li>Wstępny projekt podziału – mapa zasadnicza syt.-wys. 1:500;</li>
              <li>Mapa ewidencji gruntów 1:1000;</li>
              <li>Wypis z ewidencji gruntów.</li>
            </ol>
          </GrayPanel>
        : null}

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

OpiniaPodzialu.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(OpiniaPodzialu),
);



// WEBPACK FOOTER //
// src/routes/eservices/OpiniaPodzialu.js